module.exports = __webpack_public_path__ + "img/1564648466.581da6fa.jpg";